var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
var validationSchema = Yup.object({
    username: Yup.string().required(),
    password: Yup.string().required(),
    rememberMe: Yup.boolean()
});
export var AppLoginPage = function (_a) {
    var canBeRestored = _a.canBeRestored, signInFunc = _a.signInFunc;
    var intl = useIntl();
    var _b = useState(''), username = _b[0], setUsername = _b[1];
    var _c = useState(''), password = _c[0], setPassword = _c[1];
    var _d = useState(false), rememberMe = _d[0], setRememberMe = _d[1];
    var initialFormErrorsState = { username: null, password: null };
    var _e = useState(initialFormErrorsState), formErrors = _e[0], setFormErrors = _e[1];
    var usernamePlaceholder = intl.formatMessage({
        id: 'login.form.username'
    });
    var passwordPlaceholder = intl.formatMessage({
        id: 'login.form.password'
    });
    var restoreLink = React.createElement("p", { className: 'my-0' },
        React.createElement(Link, { to: "/restore" },
            React.createElement(FormattedMessage, { id: "login.forgot.password" })));
    var handleSetUsername = function (event) {
        var value = event.target.value;
        setUsername(value);
        try {
            Yup.reach(validationSchema, 'username').validateSync(value);
            var formErrorsNew = __assign({}, formErrors);
            formErrorsNew.username = null;
            setFormErrors(formErrorsNew);
        }
        catch (err) {
            var formErrorsNew = __assign({}, formErrors);
            formErrorsNew.username = err;
            setFormErrors(formErrorsNew);
        }
    };
    var handleSetPassword = function (event) {
        var value = event.target.value;
        setPassword(value);
        try {
            Yup.reach(validationSchema, 'password').validateSync(value);
            var formErrorsNew = __assign({}, formErrors);
            formErrorsNew.password = null;
            setFormErrors(formErrorsNew);
        }
        catch (err) {
            var formErrorsNew = __assign({}, formErrors);
            formErrorsNew.password = err;
            setFormErrors(formErrorsNew);
        }
    };
    var handleSetRememberMe = function (event) {
        setRememberMe(!!event.target.checked);
    };
    var handleSubmit = function (event) {
        event.preventDefault(); // does not allow to refresh page on submit
        try {
            validationSchema.validateSync({ username: username, password: password, rememberMe: rememberMe }, { abortEarly: false });
            signInFunc(username, password, rememberMe);
        }
        catch (err) {
            var formErrorsNew_1 = __assign({}, formErrors);
            err.inner.forEach(function (error) {
                if (error.path === 'username') {
                    formErrorsNew_1.username = error;
                }
                if (error.path === 'password') {
                    formErrorsNew_1.password = error;
                }
            });
            setFormErrors(formErrorsNew_1);
        }
    };
    return (React.createElement("div", { className: 'app-login-page' },
        React.createElement("div", { className: 'row h-75 justify-content-center align-items-center' },
            React.createElement(Form, { onSubmit: handleSubmit, "data-testid": 'submitFormLogin' },
                React.createElement(Card, null,
                    React.createElement(Card.Header, null,
                        React.createElement(FormattedMessage, { id: 'login.header' })),
                    React.createElement(Card.Body, null,
                        React.createElement(Card.Text, { as: 'div' },
                            React.createElement(Form.Group, { controlId: 'userInput' },
                                React.createElement(Form.Label, null,
                                    React.createElement(FormattedMessage, { id: 'login.form.username' })),
                                React.createElement(Form.Control, { autoFocus: true, name: 'username', type: 'text', value: username, placeholder: usernamePlaceholder, onChange: handleSetUsername, isInvalid: !!formErrors.username }),
                                React.createElement(Form.Control.Feedback, { type: 'invalid' },
                                    React.createElement(FormattedMessage, { id: 'login.form.username.invalid' }))),
                            React.createElement(Form.Group, { controlId: 'pwdInput' },
                                React.createElement(Form.Label, null,
                                    React.createElement(FormattedMessage, { id: "login.form.password" })),
                                React.createElement(Form.Control, { type: 'password', name: 'password', value: password, placeholder: passwordPlaceholder, onChange: handleSetPassword, isInvalid: !!formErrors.password }),
                                React.createElement(Form.Control.Feedback, { type: 'invalid' },
                                    React.createElement(FormattedMessage, { id: 'login.form.password.invalid' }))),
                            React.createElement(Form.Group, null,
                                React.createElement(Form.Check, { type: 'checkbox', checked: rememberMe, onChange: handleSetRememberMe, name: 'rememberMe', label: React.createElement(FormattedMessage, { id: 'login.remember.me' }), "data-testid": 'checkboxLogin' })),
                            canBeRestored && restoreLink)),
                    React.createElement(Card.Footer, null,
                        React.createElement(Button, { variant: 'primary', type: 'submit' },
                            React.createElement(FormattedMessage, { id: 'login.button' }))))))));
};
//# sourceMappingURL=app-login-page.js.map